import { Component, EventEmitter, Input, Output } from '@angular/core';
import { XsI18nPipe } from '@nx-fe/pipes';
import { hd, LoggerService } from '@nx-fe/services';
import { AttachmentService } from 'app/modules/ticket/services/attachment.service';
import { AttachmentActivity } from 'xsmodules/ticket/ticket.model';

@Component({
  selector: 'xs-email-attachment',
  templateUrl: './email-attachment-list.component.html',
  styleUrls: ['./email-attachment-list.component.scss'],
})
export class EmailAttachmentListComponent {
  @Output() onDelete = new EventEmitter<AttachmentActivity>();

  @Output() onError: EventEmitter<string> = new EventEmitter<string>();

  @Input() attachments: AttachmentActivity[];
  // Whether the parent email activity is already sent (no longer in the composition state)
  @Input() showClose: boolean | string;
  // Whether the parent email activity is being saved (or is sending)
  @Input() isDisabled: boolean | string;

  constructor(private $log: LoggerService, private $filter: XsI18nPipe, private attachmentService: AttachmentService) {}

  getFileName = (attachment: AttachmentActivity) =>
    attachment.fileName || attachment.details?.fileName || attachment.$$file?.name;

  getFileDisplayName = (attachment: AttachmentActivity) => attachment.displayName || attachment.details?.displayName;

  getFileSize = (attachment: AttachmentActivity) =>
    attachment.fileSize || attachment.details?.fileSize || attachment.$$file?.size || 0;

  /** Initiates a preview of the attachment */
  previewOrDownloadAttachment = (attachment: AttachmentActivity): void => {
    if (!this.isUploading(attachment) && !this.isDisabled) {
      const currentPreview = this.attachmentService.getPreviewAttachment();
      if (
        !currentPreview ||
        currentPreview.activityId !== attachment.activityId ||
        (currentPreview.activityId === attachment.activityId &&
          currentPreview.details?.fileId !== attachment.details?.fileId)
      ) {
        if (!this.attachmentService.setPreviewAttachment(attachment)) {
          // If the attachment can not be previewed (for example, because it's not a supported preview file type),
          // then just trigger a download
          this.download(attachment);
        }
      }
    }
  };

  deleteAttachment(attachment: AttachmentActivity) {
    this.onDelete.emit(attachment);
  }

  isUploading = (attachment: AttachmentActivity) => !attachment.details.fileId;

  /** Initiates the download of the attachment */
  private download = (attachment: AttachmentActivity): void => {
    this.attachmentService.createDownload(attachment).then(
      (downloadUrl: string) => {
        // Broadcast downloadFile event. This will be handled by the downloadFile directive
      },
      (err: hd.IError) => {
        this.$log.debug('Failed to create download');
        let message: string;
        if (err.status && err.status === 404) {
          message = this.$filter.transform('attachment_AttachmentNotFound_Error');
        } else {
          message = this.$filter.transform('attachment_DownloadFailed_Error');
        }
        this.onError.emit(message);
        err.isHandled = true;
      }
    );
  };
}
